import { render, staticRenderFns } from "./IconRoom.vue?vue&type=template&id=3f47a3cc&"
import script from "./IconRoom.vue?vue&type=script&lang=js&"
export * from "./IconRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports